/** Bottom edge (px from viewport top) available for auto-sized grid content. */
export function resolveAutoHeightBoundaryBottom(
  element: HTMLElement,
  buffer: number,
): number {
  let boundaryBottom = window.innerHeight - buffer;
  let node: HTMLElement | null = element.parentElement;

  while (node && node !== document.documentElement) {
    const style = window.getComputedStyle(node);
    const overflowY = style.overflowY;
    const maxHeight = style.maxHeight;
    const hasMaxHeight =
      maxHeight !== 'none' && maxHeight !== '' && maxHeight !== '0px';
    const isConstrainedParent =
      overflowY === 'auto' ||
      overflowY === 'scroll' ||
      overflowY === 'hidden' ||
      hasMaxHeight ||
      node.getAttribute('role') === 'dialog' ||
      node.classList.contains('MuiModal-root');

    if (isConstrainedParent) {
      const rect = node.getBoundingClientRect();
      if (rect.height > 0) {
        boundaryBottom = Math.min(boundaryBottom, rect.bottom - buffer);
      }
    }
    node = node.parentElement;
  }

  return boundaryBottom;
}
